<template>
  <v-container id="requisitar-consultor" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Selecione um Consultor
            </div>
          </template>

          <v-form
            id="form"
            ref="form"
            class="pa-3"
            lazy-validation
            @submit.prevent="criarRelacionamento"
          >
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-show="credenciais"
                    v-model="form.agroindustrias"
                    :items="form.agroindustrias"
                    value="form.agroindustrias"
                    disabled
                  />
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="form.agroconsultor"
                    label="Consultores"
                    :items="agroconsultor"
                    item-text="nome"
                    item-value="CodConsultor"
                  />
                </v-col>
              </v-row>
              <v-btn type="submit" color="success" form="form">
                Solicitar
              </v-btn>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        agroconsultor: '',
        agroindustrias: '',
        status: '1',
      },
      agroconsultor: [],
      credenciais: false,
    }
  },
  created() {
    this.carregarAgroindustria()
    this.carregarConsultor()
  },

  methods: {
    criarRelacionamento() {
      // console.log(this.form)
      this.api.post('/relacionamento/createRelacionamento', this.form)
    },

    carregarAgroindustria() {
      var idAgro = localStorage.getItem('CodAgro')
      idAgro = idAgro.substring(1, idAgro.length - 1)
      this.form.agroindustrias = idAgro
      /* this.api('/agroindustria/getDadosAgroindustriaPorEmail', {
          params: {
            emailAgro: idAgro,
          },
        })
          .then(response => {
            this.form.agroindustria = response.data
          }) */
    },

    carregarConsultor() {
      this.api('/consultor/getConsultor')
        .then(response => {
          this.agroconsultor = response.data
        })
        .catch(error => {
          this.message = error
          // console.log(this.message)
        })
    },
  },
}
</script>
